/*  eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */

// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
    registerError,
    handleError,
    accountError,
    lastWishesError,
} from "../../Actions/Errors";
import { logoutHandler, getAPIBaseUrl } from "../../Utility/Utility";
import { setAppCookie } from '../../Utility/Cookies';

// Define a service using a base URL and expected endpoints
const API_URL =  window.location.host === process.env.REACT_APP_URL_PROD ? process.env.REACT_APP_API_URL_PROD : process.env.REACT_APP_API_URL_TEST;


const baseQuery = fetchBaseQuery({
    baseUrl: window.location.host === process.env.REACT_APP_URL_PROD ? process.env.REACT_APP_API_URL_PROD : process.env.REACT_APP_API_URL_TEST,
    prepareHeaders: (headers, { getState }) => {
        // By default, if we have a token in the store, let's use that for authenticated requests
        headers.set(
            "Content-Type",
            `application/json; multipart/form-data; application/x-www-form-urlencoded`
        );
        if (getState().form?.token || localStorage.token) {
            headers.set(
                "Authorization",
                getState().form?.token || localStorage.token
            );
        }

        return headers;
    },
});
const baseQueryWithReauth = async (args, api, extraOptions) => {
    let result = await baseQuery(args, api, extraOptions);
    if (result.error && result.error.status) {
        if(result.error.data) {
            if (result.meta.request.url.includes("logout")) {
            } else if (result.meta.request.url.includes("register/code")) {
                alert(
                    registerError(
                        api.getState().form.language,
                        result.error.data,
                        true
                    )
                );
            } else if (result.meta.request.url.includes("register")) {
                alert(
                    registerError(
                        api.getState().form.language,
                        result.error.data,
                        false
                    )
                );
            } else if (result.meta.request.url.includes("login")) {
                alert(
                    accountError(
                        api.getState().form.language,
                        result.error.data,
                        false,
                        true
                    )
                );
            } else if (
                result.meta.request.url.includes("forgotPassword") &&
                result.meta.request.method === "GET"
            ) {
                alert(
                    accountError(
                        api.getState().form.language,
                        result.error.data,
                        false,
                        false
                    )
                );
            } else if (
                result.meta.request.url.includes("forgotPassword") &&
                result.meta.request.method === "POST"
            ) {
                alert(
                    accountError(
                        api.getState().form.language,
                        result.error.data,
                        true,
                        false
                    )
                );
            } else if (
                result.meta.request.url ===
                API_URL + "account"
            ) {
                alert(
                    accountError(
                        api.getState().form.language,
                        result.error.data,
                        false,
                        false
                    )
                );
            } else if (result.meta.request.url.includes("lastwishes")) {
                if (result.error?.data?.statusCode !== 404) {
                    alert(
                        lastWishesError(
                            api.getState().form.language,
                            result.error.data
                        )
                    );
                }
            } else if (result.meta.request.url.includes("systemmessage")) {
                if (result.error?.data?.statusCode !== 404) {
                    alert(
                        lastWishesError(
                            api.getState().form.language,
                            result.error.data
                        )
                    );
                }
            } else if (result.error.data) {
                
                if(result.error?.statusCode === 403) {
                    return logoutHandler();
                }else{
                    alert(handleError(api.getState().form.language, result.error.data));
                }
            } else {
                
                return logoutHandler();
            }
        }else {
                
            return logoutHandler();
        }
        
        // try to get a new token
        //const refreshResult = await baseQuery(`account/logout/${args}`, api, extraOptions);
    } else {
        setAppCookie(localStorage.token);
    }
    return result;
};
export const accountApi = createApi({
    reducerPath: "accountApi",
    baseQuery: baseQueryWithReauth,
    //keepUnusedDataFor: 60,
    refetchOnReconnect: true,
    refetchOnMountOrArgChange: true,
    endpoints: (builder) => ({
        logout: builder.query({
            query: (username) => ({
                url: `account/logout/${username}`,
            }),
        }),
        getAPICall: builder.query({
            query: (url) => ({
                url: url,
            }),
        }),
        getCall: builder.query({
            query: (url) => ({
                url: url,
            }),
        }),
        login: builder.mutation({
            query: (body) => ({
                url: "account/login",
                method: "POST",
                body: body,
            }),
        }),
        mutationAPICall: builder.mutation({
            query: (body) => ({
                url: body.url,
                method: body.method,
                body: body,
            }),
        }),
        deleteAPICall: builder.mutation({
            query: (body) => ({
                url: body.url,
                method: body.method,
            }),
        }),
        createContact: builder.mutation({
            query: (body) => ({
                url: body.url,
                method: "POST",
                body: body,
            }),
        }),
    }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useLogoutQuery,
    useGetAPICallQuery,
    useLoginMutation,
    useMutationAPICallMutation,
    useDeleteAPICallMutation,
    useGetCallQuery,
} = accountApi;
